import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tab-view',
  templateUrl: './tab-view.component.html',
  styleUrls: ['./tab-view.component.css']
})
export class TabViewComponent implements OnInit {
  @Input()
  comments;
  @Input()
  history;

  constructor() {}

  ngOnInit() {}
}
